export default "__VITE_ASSET__DPyGW488__"